<template lang="pug">
  include ./../../mixins
  +b.cabinet-modal
    +e.close(
      @click.prevent="$emit('close')"
    )
      +b.icon--type_close
    +b.bg--white.pa--f_md.--f_lg-lg
      +b.TEXT-BEMTO(
        :cfg="'center'"
        :fw="'bold'"
        :lh="'small'"
        :fs="'xl'"
        :color="'black'"
        :tag="'p'"
      ) {{ title }}
</template>

<script>
export default {
  name: 'SuccessCommon',
  props: {
    /**
     * An should be shown text, but the backend did not send a message.
     * Backend forgot send text, but I need to say something.
     */
    objectItem: {
      default: () => ({
        title: 'OK',
      }),
    },
  },
  computed: {
    /**
     * Handlers that affect the display
     * of the component.
     */
    title() {
      return this.objectItem.title
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modals/SuccessModal.vue